import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ExportLiner24 = function ExportLiner24() {
  let {
    height = 24,
    width = 24
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return /*#__PURE__*/_jsxs("svg", {
    width: "".concat(width),
    height: "".concat(height),
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M15.75 10.4596V14.2906C15.75 14.6777 15.592 15.0489 15.3107 15.3225C15.0294 15.5962 14.6478 15.75 14.25 15.75H3.75C3.35218 15.75 2.97064 15.5962 2.68934 15.3225C2.40804 15.0489 2.25 14.6777 2.25 14.2906L2.25 10.4596",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M12.6484 5.89852L8.99981 2.25M8.99981 2.25L5.35119 5.89852M8.99981 2.25L8.99984 11.007",
      stroke: "currentColor",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })]
  });
};